import Link from 'next/link'
import { useEffect, useState } from 'react'

import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'

import { CheckboxWrapper } from './CheckoutCheckboxes.styles'
import { Checkbox } from '@big-red-group/storefront-common-ui'

type VirginCheckoutCheckboxesProps = {
  allowProceedCheckout: React.Dispatch<React.SetStateAction<boolean>>
}

const CheckoutCheckboxes = ({ allowProceedCheckout }: VirginCheckoutCheckboxesProps) => {
  const defaultProperties = useDefaultProperties()
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  const [virginTcsChecked, setVirginTcsChecked] = useState({
    'virgin-tcs-1': false,
    'virgin-tcs-2': false,
    'virgin-tcs-3': false,
  })

  const handleVirginTcsChange = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setVirginTcsChecked((prevState) => ({
      ...prevState,
      [name]: event.target.checked,
    }))
  }

  useEffect(() => {
    const allChecked = Object.values(virginTcsChecked).every((checked) => checked)
    allowProceedCheckout(allChecked)
  }, [virginTcsChecked, allowProceedCheckout])

  return (
    <CheckboxWrapper>
      <Checkbox
        name="virgin-tcs-1"
        value={`${virginTcsChecked['virgin-tcs-1']}`}
        checked={virginTcsChecked['virgin-tcs-1']}
        label={
          <span>
            I agree to the{' '}
            <Link href={`${baseUrl}/en/terms-and-conditions`} target="_blank">
              Experience Oz Terms and cancellation policy
            </Link>{' '}
            and I have read the&nbsp;
            <Link href={`${baseUrl}/en/privacy-policy`} target="_blank">
              Experience Oz Privacy Policy.
            </Link>
          </span>
        }
        onChange={handleVirginTcsChange('virgin-tcs-1')}
      />
      <Checkbox
        name="virgin-tcs-2"
        value={`${virginTcsChecked['virgin-tcs-2']}`}
        checked={virginTcsChecked['virgin-tcs-2']}
        label="I am aware and accept that the transactions through this site are carried out by Experience Oz and are subject to specific terms and conditions of this site."
        onChange={handleVirginTcsChange('virgin-tcs-2')}
      />
      <Checkbox
        name="virgin-tcs-3"
        value={`${virginTcsChecked['virgin-tcs-3']}`}
        checked={virginTcsChecked['virgin-tcs-3']}
        label="I understand that Virgin Australia receives a commission from Experience Oz for bookings made via this website and that some personal information will be shared between Virgin Australia, Velocity Frequent Flyer and Experience Oz."
        onChange={handleVirginTcsChange('virgin-tcs-3')}
      />
    </CheckboxWrapper>
  )
}

export default CheckoutCheckboxes
